import { IColors } from "../interfaces"

export const theme:IColors = {
    colors: {
        text: '#FFFFFF',
        base: '#C05A21',
        primary: '#6C42D6',
        secondary: '#3A3D50',
        tertiary: '#E63A5F',
        error: '#D9534F',
        white: '#FFFFFF'
    }
}